import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import AuthCheck from '../hooks/AuthCheck';
import { Routes } from "../routes";
import welcomImage from '../assets/img/welcomMM_img.png';
const Welcome = () => {
    AuthCheck();
    const history = useHistory();
    const user = localStorage.getItem('user');
    let auth_user = '';
    let username = '';
    if (user) {
        auth_user = JSON.parse(user);
        username =auth_user?.userDetails?.employee_first_name
    }

    useEffect(() => {
        document.body.classList.add('welcome-page');
        return () => {
            document.body.classList.remove('welcome-page');
        };
    }, []);

    const handleModuleSelect = (module, path, state) => {
        localStorage.setItem('selectedModule', module);
        window.dispatchEvent(new CustomEvent('selectedModuleChanged', { detail: module }));
        history.push({ pathname: path, state });
    };

    return (
        <div className="welcome-container d-flex flex-column align-items-center">
            <div className='d-flex space-between welcome-banner' style={{}}>
            <div>

            <h2 className="welcome-title">Welcome, {auth_user && username}</h2>
            <p className="welcome-subtitle">Your workspace is ready. Pick an app below to get started.</p>
            </div>
            <div className="welcome-banner-img" >
                <img src={welcomImage} alt="Welcome image" />
            </div>
            </div>

            {/* <div className="section w-100">
                <h6 className="section-title">My favourites</h6>
                <div className="grid-2">
                    <Link
                        to={{ pathname: "/dashboardoverview", state: { section: "Admin" } }}
                        className="app-card"
                        onClick={() => handleModuleSelect('Admin')}
                    >
                        <div className="icon user-icon"></div>
                        <div className="app-info">
                            <strong>Admin</strong>
                            <p>Manage users, permissions, and system settings</p>
                        </div>
                    </Link>
                    <Link
                        to={Routes.DashboardOverview.path}
                        className="app-card"
                        onClick={() => handleModuleSelect('Inventory')}
                    >
                        <div className="icon inventory-icon"></div>
                        <div className="app-info">
                            <strong>ERP Inventory</strong>
                            <p>Manage stock levels and streamline warehouse operations</p>
                        </div>
                    </Link>
                </div>
            </div> */}

            <div className="section w-100" >
                <h6 className="section-title">My Apps</h6>
                <div className="grid-2">
                    <div
                        className="app-card"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleModuleSelect('Admin', '/dashboardoverview', { section: 'Admin' })}
                    >
                        <div className="icon user-icon"></div>
                        <div className="app-info">
                            <strong>Admin</strong>
                            <p>Centralize and manage organizational information and user permissions</p>
                        </div>
                    </div>
                    <div
                        className="app-card"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleModuleSelect('Procurement', '/dashboardoverview', { section: 'Procurement' })}
                    >
                        <div className="icon procurement-icon"></div>
                        <div className="app-info">
                            <strong>ERP Procurement</strong>
                            <p>Manage supplier information, track purchase orders and distribute products</p>
                        </div>
                    </div>
                    <div
                        className="app-card"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleModuleSelect('Inventory', Routes.DashboardOverview.path, { section: 'Inventory' })}
                    >
                        <div className="icon inventory-icon"></div>
                        <div className="app-info">
                            <strong>ERP Inventory</strong>
                            <p>Manage product catalogs, count stock quantities and initiate internal transfer</p>
                        </div>
                    </div>
                    <div
                        className="app-card"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleModuleSelect('Sales', Routes.ListingPricing.path, { section: 'Sales' })}
                    >
                        <div className="icon sales-icon"></div>
                        <div className="app-info">
                            <strong>ERP Sales</strong>
                            <p>Manage operations related to listings, pricing and sales orders</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Welcome;